<script setup lang="ts">
import { ref, computed } from 'vue';
import { PTooltip, PTooltipContent, PTooltipProvider, PTooltipTrigger } from '@pokerly/ui';
import { EmojiQuickPicker } from '@/components/emoji/index.js';
import type { EmojiData } from 'emoji-mart-vue-fast/src';

const emojiPickerModel = defineModel<boolean>({
    default: false,
});

defineEmits<{
    'update:open': [value: boolean];
    select: [emoji: EmojiData];
}>();

const tooltipModel = ref(false);
const shouldTooltipOpen = computed(() => emojiPickerModel.value || tooltipModel.value);

function handleTooltipChange(open: boolean) {
    tooltipModel.value = open;
}
</script>

<template>
    <PTooltipProvider>
        <PTooltip @update:open="handleTooltipChange" :open="shouldTooltipOpen">
            <PTooltipTrigger as-child>
                <slot></slot>
            </PTooltipTrigger>
            <PTooltipContent variant="unstyled">
                <EmojiQuickPicker v-model:open="emojiPickerModel" @select="(v) => $emit('select', v)" />
            </PTooltipContent>
        </PTooltip>
    </PTooltipProvider>
</template>
